export default __webpack_public_path__ + "static/media/banner-3.d226b78a.jpg";